export default __webpack_public_path__ + "static/media/take-action.0a07b9a0.svg";